module.exports = "/images/affiche-depart.png?6730fb2b525358c7b0c0ef34bb9db79d";